<template>
  <v-dialog v-model="showDialog" persistent max-width="500px">
    <v-card class="ukpl-blue-card py-4 px-2 text-center" dark>
      <v-card-title class="headline justify-center white--text pb-4">
        Verify Your Email
      </v-card-title>
      
      <v-card-text>
        <p class="white--text mb-6">
          To secure your account, we have sent a 6-digit verification code to
          <strong>{{ currentUser ? currentUser.email : '' }}</strong>.
          <br />Please enter it below to continue.
        </p>

        <v-form ref="form" v-model="valid" @submit.prevent="verifyOtp">
          <v-text-field
            v-model="otpCode"
            label="6-Digit Code"
            outlined
            color="white"
            class="centered-input"
            maxlength="6"
            counter="6"
            :rules="[v => !!v || 'Code is required', v => v.length === 6 || 'Code must be 6 digits']"
          ></v-text-field>

          <v-alert v-if="errorMessage" type="error" dense outlined class="mt-2 text-left">
            {{ errorMessage }}
          </v-alert>
          <v-alert v-if="successMessage" type="success" dense outlined class="mt-2 text-left">
            {{ successMessage }}
          </v-alert>

          <v-btn
            color="red accent-3"
            class="mt-4 mb-2"
            block
            rounded
            large
            type="submit"
            :loading="loadingVerify"
          >
            Verify Email
          </v-btn>

          <v-btn
            color="blue lighten-1"
            text
            block
            rounded
            small
            @click="resendCode"
            :loading="loadingResend"
            class="mt-2"
          >
            Didn't receive a code? Resend
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EmailVerificationDialog",
  data() {
    return {
      otpCode: "",
      valid: false,
      loadingVerify: false,
      loadingResend: false,
      errorMessage: "",
      successMessage: ""
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    // The dialog automatically shows if the user is logged in but their email is NOT verified
    showDialog() {
      if (this.currentUser) {
        if (this.currentUser.emailVerified === false) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    verifyOtp() {
      if (this.$refs.form.validate()) {
        this.loadingVerify = true;
        this.errorMessage = "";
        this.successMessage = "";

        this.$store.dispatch("auth/verifyEmail", {
          email: this.currentUser.email,
          code: this.otpCode
        })
        .then(() => {
          this.loadingVerify = false;
          this.successMessage = "Email verified successfully!";
          // The store mutation verifyEmailSuccess flips currentUser.emailVerified to true,
          // which automatically closes the dialog via the showDialog computed property.
        })
        .catch(error => {
          this.loadingVerify = false;
          this.errorMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString();
        });
      }
    },
    resendCode() {
      this.loadingResend = true;
      this.errorMessage = "";
      this.successMessage = "";

      this.$store.dispatch("auth/resendOtp", this.currentUser.email)
        .then(() => {
          this.loadingResend = false;
          this.successMessage = "A new code has been sent to your email!";
        })
        .catch(error => {
          this.loadingResend = false;
          this.errorMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString();
        });
    }
  }
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.2rem;
}
.ukpl-blue-card {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
}
</style>
